import React from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'

import '../Home/Home.css'
import Button from '../Form/Button'

export default class Fiscalizacao extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            ficha: { tipoBusca: '', info: '', estado: '', user: localStorage.nome }, list: [],
            fiscais: [], loaded: false
        }
    }

    componentDidMount() {
        const url = '/api/user/getFiscais'
        axios(url)
            .then(resp => {
                this.setState({ fiscais: [...resp.data] })
            })
            .catch(error => {
                alert(error.response.data)
            }
            )
    }

    updateField(event) {
        const ficha = { ...this.state.ficha }
        ficha[event.target.name] = event.target.value
        this.setState({ ficha })
    }

    busca(e) {
        const ficha = this.state.ficha
        const url = '/api/processo/busca'
        axios.post(url, ficha)
            .then(resp => {
                this.setState({ list: resp.data })
                this.setState({ loaded: true })
            })
            .catch(error => {
                alert(error.response.data)
            })
    }

    render() {
        return (
            <div className="container form-group mx-auto row">
                <label className="col-2 mt-3">Buscar por:</label>
                <div className="col-10 col-md-4 mt-3">
                    <select className="custom-select"
                        name="tipoBusca"
                        onChange={e => this.updateField(e)} >
                        <option value=""></option>
                        <option value="data">Data</option>
                        <option value="numero">Número</option>
                        <option value="nome">Nome do Estabelecimento</option>
                        <option value="situacao">Situação</option>
                        <option value="fiscal">Fiscal</option>
                    </select>
                </div>
                {this.renderTipo()}
                <div className="col-12 mt-3">
                    <Button onClick={e => this.busca(e)} />
                </div>
                <div className="container mx-auto">
                    <div className="text-center mx-auto">
                        <table className="table mt-4">
                            <thead>
                                <tr>
                                    <th>PROCESSO</th>
                                    <th>SITUAÇÃO</th>
                                    <th>ESTABELECIMENTO</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.renderRows()}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }

    renderRows() {
        return this.state.list.map(ficha => {
            if (ficha.setor == "Aguardando prazo") {
                if (ficha.prazo) {
                    let hoje = new Date().getTime()
                    let prazo = Date.parse(ficha.prazo)
                    let final = new Date(prazo - hoje)
                    // let resto = final.toDateString().slice(8,10)
                    let resto = Math.floor((prazo - hoje) / 86400000) + 1

                    // var diff = Math.abs(prazo - hoje)
                    // console.log(ficha.numero, ":", Math.floor((prazo - hoje)/86400000) + 1)
                    return (
                        <tr key={ficha.id}>
                            <td>{ficha.numero}</td>
                            <td>{ficha.setor}({ficha.setorDestino}) : {resto} dias</td>
                            <td>{ficha.estabelecimento}</td>
                            <td>
                                <Link to={`/documentos/${ficha._id}`} target="_blank" params={ficha}>
                                    <button style={{
                                        border: "none", backgroundColor: "#28a745",
                                        paddingTop: "5px", paddingBottom: "5px",
                                        paddingLeft: "12px", paddingRight: "12px",
                                        borderRadius: "15px", color: "#FFFF"
                                    }}>Abrir</button>
                                </Link>
                            </td>
                        </tr>
                    )
                }
            } else {
                return (
                    <tr key={ficha.id}>
                        <td>{ficha.numero}</td>
                        <td>{ficha.setor}</td>
                        <td>{ficha.estabelecimento}</td>
                        <td>
                            <Link to={`/documentos/${ficha._id}`} params={ficha}>
                                <button style={{
                                    border: "none", backgroundColor: "#28a745",
                                    paddingTop: "5px", paddingBottom: "5px",
                                    paddingLeft: "12px", paddingRight: "12px",
                                    borderRadius: "15px", color: "#FFFF"
                                }}>Abrir</button>
                            </Link>
                        </td>
                    </tr>
                )
            }
        })
    }

    renderTipo() {
        if (this.state.ficha.tipoBusca == 'data') {
            return (
                <React.Fragment>
                    <label className="col-2 mb-3 mt-3">Data:</label>
                    <div className="col-10 col-md-4 mb-3 mt-3">
                        <input type="date" className="form-control"
                            name="info"
                            onChange={e => this.updateField(e)} />
                    </div>
                    <label className="col-5 col-md-2">Estado:</label>
                    <div className="col-7 col-md-4">
                        <select className="custom-select"
                            name="estado"
                            onChange={e => this.updateField(e)} >
                            <option value="Todos">Todos</option>
                            <option value="AL">Alagoas</option>
                            <option value="PB">Paraíba</option>
                            <option value="PE">Pernambuco</option>
                            <option value="RN">Rio Grande do Norte</option>
                        </select>
                    </div>
                </React.Fragment>
            )
        }
        else if (this.state.ficha.tipoBusca == 'numero') {
            return (
                <React.Fragment>
                    <label className="col-2 mt-3">Número:</label>
                    <div className="col-10 col-md-4 mt-3">
                        <input type="text" className="form-control"
                            name="info"
                            onChange={e => this.updateField(e)} />
                    </div>
                </React.Fragment>
            )
        }
        else if (this.state.ficha.tipoBusca == 'nome') {
            return (
                <React.Fragment>
                    <label className="col-5 col-md-2 mt-3">Estabelecimento:</label>
                    <div className="col-7 col-md-4 mt-3">
                        <input type="text" className="form-control"
                            name="info"
                            onChange={e => this.updateField(e)} />
                    </div>
                </React.Fragment>
            )
        }
        else if (this.state.ficha.tipoBusca == 'situacao') {
            return (
                <React.Fragment>
                    <label className="col-5 col-md-2 mb-3 mt-3">Situação:</label>
                    <div className="col-7 col-md-4 mb-3 mt-3">
                        <select className="custom-select"
                            name="info"
                            onChange={e => this.updateField(e)} >
                            <option value=""></option>
                            <option value="Coordenação">Coordenação</option>
                            <option value="Revisita">Revisita</option>
                            <option value="Arquivo">Arquivo</option>
                            <option value="Aguardando prazo">Aguardando prazo</option>
                            <option value="Processo Ético">Processo Ético</option>
                            <option value="Presidência">Presidência</option>
                            <option value="Novo">Novo</option>
                            <option value="Assessoria Jurídica">Assessoria Jurídica</option>
                            <option value="AJUR Contencioso Notícia Crime">AJUR Notícia Crime</option>
                            <option value="AJUR Contencioso Diversos">AJUR Contencioso Diversos</option>
                            <option value="Administrativo">Administrativo</option>
                        </select>
                    </div>
                    <label className="col-5 col-md-2">Estado:</label>
                    <div className="col-7 col-md-4">
                        <select className="custom-select"
                            name="estado"
                            onChange={e => this.updateField(e)} >
                            <option value="Todos">Todos</option>
                            <option value="AL">Alagoas</option>
                            <option value="PB">Paraíba</option>
                            <option value="PE">Pernambuco</option>
                            <option value="RN">Rio Grande do Norte</option>
                        </select>
                    </div>
                    {this.renderSub()}
                </React.Fragment>
            )
        }
        else if (this.state.ficha.tipoBusca == 'fiscal') {
            return (
                <React.Fragment id="mutavel">
                    <label className="col-2 mt-3">Fiscal:</label>
                    <div className="col-10 col-md-4 mt-3">
                        <select className="custom-select"
                            name="fiscal"
                            onChange={e => this.updateField(e)} >
                            <option value=""></option>
                            {this.renderFiscais()}
                        </select>
                    </div>
                </React.Fragment>
            )
        }
    }

    renderSub() {
        if (this.state.ficha.info == "Aguardando prazo") {
            return (
                <React.Fragment>
                    <label className="col-5 col-md-2">Setor:</label>
                    <div className="col-7 col-md-4">
                        <select className="custom-select"
                            name="setorDestino"
                            onChange={e => this.updateField(e)} >
                            <option value=""></option>
                            <option value="Revisita">Revisita</option>
                            <option value="Arquivo">Arquivo</option>
                            <option value="Processo Ético">Processo Ético</option>
                            <option value="Presidência">Presidência</option>
                            <option value="Assessoria Jurídica">Assessoria Jurídica</option>
                            <option value="AJUR Contencioso Notícia Crime">AJUR Notícia Crime</option>
                            <option value="AJUR Contencioso Diversos">AJUR Contencioso Diversos</option>
                            <option value="Denúncia">Denúncia</option>
                            <option value="Coordenação">Coordenação</option>
                            <option value="Administrativo">Administrativo</option>
                        </select>
                    </div>
                </React.Fragment>
            )
        }
    }

    renderFiscais() {
        let select = []
        this.state.fiscais.map(ficha => {
            select.push(<option value={ficha.nome}>{ficha.nome}</option>)
        })
        return select
    }
}